/* eslint-disable no-console */
let newObsLocalData = (function () {
  const LOCAL_KEY = "__gpNewOnboardingStep";

  function getShopName(_count) {
    if (!_count) {
      _count = 0;
    }
    let result;
    if (window.dataLayer && window.dataLayer.length > 0) {
      const _store = window.dataLayer.filter(store => store.__store);
      if (_store.length > 0) {
        result = _store[0].__store;
      }
    }
    if (!result) {
      setTimeout(() => {
        if (_count < 5) {
          _count++;
          getShopName(_count);
        }
      }, 100);
    }
    return result;
  }

  function getFirstName(_count) {
    let result;
    if (!_count) {
      _count = 0;
    }
    if (window.dataLayer && window.dataLayer.length > 0) {
      const _store = window.dataLayer.filter(store => store.__first_name);
      if (_store.length > 0) {
        const name = _store[0].__first_name || "";
        result = name.charAt(0).toUpperCase() + name.slice(1)
      }
    }
    if (!result) {
      setTimeout(() => {
        if (_count < 5) {
          _count++;
          this.getFirstName(_count);
        }
      }, 100);
    }

    return result;
  }

  function getAllData() {
    let result = [];
    try {
      result = JSON.parse(window.localStorage.getItem(LOCAL_KEY));
    } catch (error) {
      console.log(error)
    }
    return result;
  }

  function removeAllData() {
    window.localStorage.removeItem(LOCAL_KEY);
  }

  /**
   * Function to set a cookie
   * @param {Object JSON} data local survey data
   * @param {String} shopifyDomain shopify Domain
   */
  function setData(data, key, shopifyDomain) {
    if (!key) {
      key = "All";
    }
    if (!shopifyDomain) {
      shopifyDomain = getShopName();
    }
    let localAllData = getAllData();
    if (localAllData && localAllData.length > 0) {
      // đã tồn tại
      localAllData.forEach(ld => {
        if (ld.shopifyDomain == shopifyDomain) {
          if (key == "All") {
            ld.store = data;
          } else {
            ld.store[key] = data;
          }
        } else {
          ld.shopifyDomain = shopifyDomain
        }
      });
      window.localStorage.setItem(LOCAL_KEY, JSON.stringify(localAllData));
    } else {
      // chưa tồn tại
      let ld = {};
      localAllData = [];
      if (key == "All") {
        localAllData.push({
          shopifyDomain: shopifyDomain,
          store: data
        });
      } else {
        ld.store = {}
        ld["shopifyDomain"] = shopifyDomain;
        ld["store"][key] = data;
        localAllData.push(ld);
      }
      window.localStorage.setItem(LOCAL_KEY, JSON.stringify(localAllData));
    }
  }

  function getData(shopifyDomain) {
    // if(!shopifyDomain){
    //   shopifyDomain = getShopName();
    // }
    let result;
    const localDataJson = getAllData();
    if (localDataJson && localDataJson.length > 0) {
      const datObj = localDataJson.filter(shop => shop.shopifyDomain == shopifyDomain);
      if (datObj && datObj.length > 0) {
        result = datObj[0];
      }
    }
    return result;
  }

  function removeData(shopifyDomain) {
    if (!shopifyDomain) {
      shopifyDomain = getShopName();
    }
    const surveyData = getAllData() || [];
    if (surveyData && surveyData.length > 0) {
      const dataRemain = surveyData.filter(shop => shop.shopifyDomain != shopifyDomain);
      console.log("dataRemain", dataRemain)
      if (dataRemain && dataRemain.length > 0) {
        window.localStorage.setItem(LOCAL_KEY, JSON.stringify(dataRemain));
      } else if (dataRemain && dataRemain.length == 0 && surveyData.length == 1) {
        removeAllData();
      }
    }
  }

  function checkExisted(shopifyDomain) {
    let result = false;
    const localDataJson = getData(shopifyDomain);
    if (localDataJson) {
      result = true;
    }
    return result;
  }


  return {
    get: getData,
    getAll: getAllData,
    set: setData,
    remove: removeData,
    removeAll: removeAllData,
    check: checkExisted,
    getName: getFirstName,
    getShopName: getShopName
  };
})();

export default newObsLocalData;
